export default __webpack_public_path__ + "static/media/icon-s-hand.003c1676.svg";